import { render, staticRenderFns } from "./writeoffDetail.vue?vue&type=template&id=89065c22&scoped=true&"
import script from "./writeoffDetail.vue?vue&type=script&lang=js&"
export * from "./writeoffDetail.vue?vue&type=script&lang=js&"
import style0 from "./writeoffDetail.vue?vue&type=style&index=0&id=89065c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89065c22",
  null
  
)

/* custom blocks */
import block0 from "./writeoffDetail.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports